import { MjmlColumn, MjmlSection } from "@faire/mjml-react";
import {
  EmailBlockType,
  Section,
  SharedProps,
} from "@redotech/redo-model/email-builder";
import { memo } from "react";
// can't import emailBlocks because it has a circular dependency
import { emailBlocksExceptColumn } from "../email-builder-component-prop-data-types";
import { nestedEmailBlocks } from "../nested-email-blocks";

export type ColumnState = Section.Column & SharedProps;

export const EmailColumn = memo(function EmailColumn(props: ColumnState) {
  const padding = props.sectionPadding;

  const sharedProps = {
    format: props.format,
    team: props.team,
    template: props.template,
    schemaInstance: props.schemaInstance,
    utm: props.utm,
    isBuilder: props.isBuilder,
  };

  return (
    <MjmlSection
      backgroundColor={props.sectionColor}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
    >
      {Array.from({ length: props.columnCount }).map((_, index) => {
        const column = props.columns[index];
        if (!column) return <MjmlColumn key={index} />;
        if (column.type === EmailBlockType.COLUMN) {
          return null; // no nested columns
        }
        const Block = emailBlocksExceptColumn[column.type].Component;
        const NestedBlock = nestedEmailBlocks[column.type];

        if (!Block) return null;

        return (
          <MjmlColumn key={index}>
            {nestedEmailBlocks[column.type] ? (
              NestedBlock ? (
                <NestedBlock {...column} {...sharedProps} />
              ) : null
            ) : (
              <Block {...column} {...sharedProps} />
            )}
          </MjmlColumn>
        );
      })}
    </MjmlSection>
  );
});
